import { NormalizedStore } from '@store/entity/entity.types';
import { guestPickerValidationTrigger } from '@store/guestPickerValidation';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { connect } from 'react-redux';
import { BookableListItem } from './BookableListItem';

const mapStateToProps = (state: NormalizedStore) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch) => ({
  triggerValidation: () => dispatch(guestPickerValidationTrigger()),
});

export const BookableListItemConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(BookableListItem);
